const MESES_LABELS = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

interface MonthNavProps {
  mes: number; // 1-12
  ano: number;
  onChange: (mes: number, ano: number) => void;
}

export default function MonthNav({ mes, ano, onChange }: MonthNavProps) {
  function prev() {
    if (mes === 1) onChange(12, ano - 1);
    else onChange(mes - 1, ano);
  }

  function next() {
    if (mes === 12) onChange(1, ano + 1);
    else onChange(mes + 1, ano);
  }

  return (
    <div className="flex items-center justify-between px-1 py-2">
      <button
        onClick={prev}
        className="w-8 h-8 flex items-center justify-center rounded-lg text-dark-muted hover:text-dark-text hover:bg-dark-card2 transition-all cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      <div className="flex flex-col items-center">
        <span className="text-sm font-semibold text-dark-text tracking-wide">
          {MESES_LABELS[mes - 1]}
        </span>
        <span className="text-[10px] text-dark-muted">{ano}</span>
      </div>

      <button
        onClick={next}
        className="w-8 h-8 flex items-center justify-center rounded-lg text-dark-muted hover:text-dark-text hover:bg-dark-card2 transition-all cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </div>
  );
}
